import {
  Synonym, Word, Phrase, WordProperty,
} from '@/interfaces/class/word';

const createPropertiesArray = (data: WordProperty[], type: string) => {
  const properties : string[] = [];
  const synonyms : string[] = [];

  data.forEach((word: WordProperty) => {
    if (word.wordProperty && word.translationProperty) {
      const wordId = word.wordProperty.split('word_properties/')[1];
      const translationId = word.translationProperty.split('translation_properties/')[1];

      properties.push(`${wordId}:${translationId}`);
      synonyms.push(wordId);
    }
  });

  return {
    properties,
    synonyms,
    type,
  };
};

const isNeedLoadVocabulary = (state: {
  exercise: {
    currentExercise: {
      alias: string;
      data: WordProperty[];
    };
  };
}) => {
  const {
    exercise: { currentExercise: { alias, data } },
  } = state;

  const isWords = alias === 'flash-card' || alias === 'vocabulary' || alias === 'lesson-test';
  const isPhrases = alias === 'lets-practice' || alias === 'phrasebook';
  const type = isWords ? 'words' : 'phrases';

  if (isWords || isPhrases) {
    return createPropertiesArray(data, type);
  }

  return {
    properties: [],
    synonyms: [],
    type,
  };
};

const updateVocabularyArray = (response: {
  getWordProperties: Word[];
  getWordSynonyms: Synonym[];
}) => {
  const words = response?.getWordProperties || [];
  const synonyms = response?.getWordSynonyms || [];
  const vocabulary : {
    [key: string]: Word;
  } = {};

  words.forEach((word: Word) => {
    vocabulary[word.wordProperty.wordPropertyId] = word;
  });

  synonyms.forEach((synonym: Synonym) => {
    const word = synonym.wordProperty.wordPropertyId;

    if (vocabulary[word]) {
      const wordSynonyms = vocabulary[word].synonyms || [];

      // @ts-ignore
      if (wordSynonyms.length < 2) wordSynonyms.push(synonym.synonym);

      vocabulary[word] = {
        ...vocabulary[word],
        synonyms: wordSynonyms,
      };
    }
  });

  return vocabulary;
};

const updatePhrasesArray = (response: {
  getPhrases: Phrase[];
}) => {
  const phrases = response?.getPhrases || [];
  const vocabulary : {
    [key: string]: Phrase;
  } = {};

  phrases.forEach((phrase: Phrase) => {
    vocabulary[phrase.wordPropertyId] = phrase;
  });

  return vocabulary;
};

const checkIsNeedDontKnow = (
  response: {
    data: {
      getClientState: {
        state: string;
        value: string;
      }[];
    };
  },
  currentId: string,
) => {
  const state = response?.data?.getClientState;
  const stateName = `dontKnowTrainings_${currentId}`;
  const isExist = !!state.filter((el: { state: string; }) => el.state === stateName).length;

  if (!isExist) return true;

  return false;
};

export {
  createPropertiesArray,
  updateVocabularyArray,
  isNeedLoadVocabulary,
  checkIsNeedDontKnow,
  updatePhrasesArray,
};
